<div [ngClass]="classList.length > 0 ? classList : ''" [attr.title]="tooltip">
  <ng-container *ngComponentOutlet="iconComponents[getIcon]"></ng-container>
</div>
